import { render } from "./PracticeTestTakeView.vue?vue&type=template&id=3c672db1&scoped=true"
import script from "./PracticeTestTakeView.vue?vue&type=script&lang=js"
export * from "./PracticeTestTakeView.vue?vue&type=script&lang=js"

import "./PracticeTestTakeView.vue?vue&type=style&index=0&id=3c672db1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c672db1"]])

export default __exports__